import type { PropsWithChildren } from 'react'

import { PostHogProvider } from 'posthog-js/react'

import { POSTHOG_API_KEY, POSTHOG_PROXY } from './constant'

export function YesPosthogProvider({ children }: PropsWithChildren) {
  return (
    <PostHogProvider
      apiKey={POSTHOG_API_KEY}
      options={{
        api_host: POSTHOG_PROXY,
        capture_pageleave: false,
        capture_pageview: true,
        autocapture: true,
        person_profiles: 'identified_only',
      }}
    >
      {children}
    </PostHogProvider>
  )
}
